import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ParcellaSoggettoAdapter } from '../../components/fascicolo/parcelle-ripartizione/parcella-soggetto-adapter';
import { Controparte } from '../../models/controparte';
import { FascicoloFull } from '../../models/fascicolo/fascicolo-full';
import { ParcellaGiudiziale } from '../../models/parcella-giudiziale';
import { ParcellaSoggetto } from '../../models/parcella-soggetto';
import { ParcellaStragiudiziale } from '../../models/parcella-stragiudiziale';
import { PetitumRevisione } from '../../models/petitum-revisione';
import { SezioneEconomica } from '../../models/sezioni/sezione-economica';
import { SoggettoPratica } from '../../models/tipologiche/soggetto-pratica';
import { NumericOperationManager } from '../../utils/numeric-operation-manager';
import { BaseForm } from '../base-Form';

export abstract class ParcellaFormRipartizione extends BaseForm {

  request: ParcellaSoggetto;
  parcella: ParcellaGiudiziale | ParcellaStragiudiziale;
  fascicolo: FascicoloFull;
  ripartizioneForm: FormGroup;
  soggettoOptions: SoggettoPratica[]=[];
  msgNoBeneficiari: string;

  sezioneEconomica: SezioneEconomica;
  lastRevisionePetitum: PetitumRevisione;

  importoParcellaDefault:number;

  abstract getRipartizioneNotula(): ParcellaSoggetto;
  abstract getUrlReadSezioneControparti(): string;
  abstract getUrlReadSezioneEconomica(): string;
  abstract getRequest(ripartizione: ParcellaSoggetto);

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected modalNotifyService: ModalNotifyService) {
    super();
  }

 initRequest() {
    this.request = new ParcellaSoggettoAdapter(this.getRipartizioneNotula(), this.parcella).parcellaSoggetto;
    this.importoParcellaDefault=this.parcella.importoParcella;
    this.onChangePercentuale(this.request.percentualeParcella);
  }

  createForm() {
      this.initRequest();
      this.ripartizioneForm = this.campiForm.group({
      soggetto: [this.request.soggetto, Validators.required],
      percentualeParcella: [this.request.percentualeParcella, Validators.required],
      importoParcella: [this.request.parcella ? this.request.parcella.importoParcella : 0]
    });
  }

  populateSelect() {
    if (this.soggettoOptions.length === 0) {
      // const tipoPratica = this.fascicolo.praticaBase.tipoPratica.endpoint;
      // if (PropertiesSettings.ID_TENANTS_FS()) {
      //   this.helpers.getSoggetti().subscribe(response => {
      //     if (PropertiesSettings.PRATICHE_CON.includes(tipoPratica)) {
      //       this.soggettoOptions = response.filter(el => el.sigla !== 'CD');
      //     } else if (PropertiesSettings.PRATICHE_CD.includes(tipoPratica)) {
      //       this.soggettoOptions = response.filter(el => el.sigla !== 'CON');
      //     } else {
      //       this.soggettoOptions = response;
      //     }
      //   });
      // } else {
      //   this.helpers.getSoggetti().subscribe(response => this.soggettoOptions = response);
      // }
      this.helpers.getSoggetti().subscribe(response=>this.soggettoOptions = response.filter(element=> element.siglia === 'CON' || !element.sigla));
    }
  }

  onChangePercentuale(event){
    if(event){
      this.request.parcella.importoParcella = event === 0 
        ? 0 
        : parseFloat((this.importoParcellaDefault * (event / 100)).toFixed(2));
    }
    else{
      this.request.parcella.importoParcella = parseFloat(this.importoParcellaDefault.toFixed(2));
    }
  }

  update() {
    this.getRequest(this.request);
  }

  getSoggettoLabel(soggettoPagatore: Controparte): string {
    let result = '';
    if (soggettoPagatore && soggettoPagatore.parte && soggettoPagatore.parte.tipoPersona) {
      if (soggettoPagatore.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_FISICA) {
        result = soggettoPagatore.parte.cognome + ' ' + soggettoPagatore.parte.nome;
      }
      if (soggettoPagatore.parte.tipoPersona.label === PropertiesSettings.LABEL_TIPO_PERSONA_GIURIDICA) {
        result = soggettoPagatore.parte.ragioneSociale;
      }
    }
    return result;
  }

//   getControparte(obj: any) {
//     if (obj && obj.id) {
//       this.request.soggettoPagatore =  this.soggettiPagatoriOptions.filter(controparte => { return controparte.id === obj.id; })[0];
//     }
//   }

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  stringToNumber(a: string): number {
    return Number(a);
  }

}
